import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { GoodLeafPercentageReport } from './Pages'

export const GoodLeafPercentageReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={GoodLeafPercentageReport} />
    </Fragment>
)